import { render, staticRenderFns } from "./DualSelectLists.vue?vue&type=template&id=3b6e5f98&"
import script from "./DualSelectLists.vue?vue&type=script&lang=js&"
export * from "./DualSelectLists.vue?vue&type=script&lang=js&"
import style0 from "./DualSelectLists.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VDataTable,VFlex,VIcon,VLayout,VTextField})
